export default __webpack_public_path__ + "static/media/trip.89bbe885.svg";